import vm from '~/main'
export default {
  $checkNavigationGuardianChange: (key, arrayKey) => {
    return arrayKey
      ? vm.$store.state.navigationGuardian.navigationGuardianChangeData[key][arrayKey]
      : vm.$store.state.navigationGuardian.navigationGuardianChangeData[key]
  },
  $navigationGuardianObjectDefault: (key) => {
    return vm.$store.state.navigationGuardian.navigationGuardianCheckData[key]
  },
}
